import { createSlice } from '@reduxjs/toolkit'

export const cartSlice = createSlice({
  name: "cart",
  initialState: {
    store: []
  },
  reducers: {
    addToCart: (state, action) => {
      state.store.push(action.payload)
    },
    removeToCart: (state, action) => {
      state.store.splice(action.payload, 1)
    },
    increaseQuantity: (state, action) => {
      state.store[action.payload].quantity++
    },
    decreaseQuantity: (state, action) => {
      state.store[action.payload].quantity--
    },
    reInitStore: (state) => {
      state.store = []
    }
  }
})

export const { addToCart, removeToCart, increaseQuantity, decreaseQuantity, reInitStore } = cartSlice.actions

export default cartSlice.reducer